module.exports = __webpack_public_path__ + "static/media/step-2-schedule.ae68d2b1.png";